import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ZyCommonErrorNodeView } from './zycommonerror-node-view';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zyCommonError: {
            insertZyCommonError: () => ReturnType;
        };
    }
}

export const ZyCommonErrorHeadless = Node.create({
    name: 'zyCommonError',

    content: 'text*',

    group: 'block',

    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => {
                    return element.getAttribute('id');
                },
                renderHTML: attributes => {
                    if (!attributes.id) {
                        return {};
                    }
                    return {
                        id: attributes.id,
                    };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'zyCommonError',
                getAttrs: element => {
                    if (!(element instanceof HTMLElement)) {
                        return false;
                    }
                    return {
                        id: element.getAttribute('id'),
                    };
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['zyCommonError', HTMLAttributes, 0];
    },

    addCommands() {
        return {
            insertZyCommonError:
                () =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: this.name,
                        attrs: {
                            id: null,
                        },
                        content: [
                            {
                                type: 'paragraph',
                                content: [
                                    {
                                        type: 'text',
                                        text: 'Text goes here. must include the words "common error"',
                                    },
                                ],
                            },
                        ],
                    });
                },
        };
    },
});

export const ZyCommonError = ZyCommonErrorHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyCommonErrorNodeView);
    },
});

export default ZyCommonError;
